__turbopack_context__.v({
  "bannerHeading": "banner-module__mR6iYq__bannerHeading",
  "bannerText": "banner-module__mR6iYq__bannerText",
  "hero": "banner-module__mR6iYq__hero",
  "heroContent": "banner-module__mR6iYq__heroContent",
  "pageWrapper": "banner-module__mR6iYq__pageWrapper",
});
